import React from "react";
import { Paper, Box, Typography } from "@material-ui/core";
import Stack from "@mui/material/Stack";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import { DatePickerView } from "@mui/lab/DatePicker/shared";
import { DatePicker, LocalizationProvider } from "@mui/lab";
import { TextField } from "@mui/material";
import { ColorUtils } from "../utils/ColorUtils";

export const MIN_DATE = new Date("2020-03-01");
export const MAX_DATE = new Date("2030-06-01");
export const CURRENT_YEAR_MAX_DATE = new Date(new Date().getFullYear(), 11, 31);

interface Props {
  title: string;
  icon?: string;
  elevation?: number;
  rightContent?: JSX.Element;
  children?: React.ReactNode;
}

export const AppToolbar = ({ title, elevation = 0, rightContent, children, icon }: Props) => {
  return (
    <Box paddingBottom={0}>
      <Paper elevation={elevation} style={{ paddingBottom: "5px" }}>
        <Box style={{ display: "flex", flexWrap: "wrap", alignItems: "flex-end", justifyContent: "space-between" }}>
          <Typography variant="h6" style={{ color: ColorUtils.ENSOLVERS_ORANGE_REBRANDING, padding: "0 0 0.5em 0", fontWeight:"bold" }}>
            {icon && <img src={icon} style={{marginRight: "0.25em"}}/>} 
            {title}
          </Typography>

          {!!rightContent && rightContent}
        </Box>

        <div style={{ display: "flex", marginBottom: "0px", alignItems: "flex-start", marginTop: "0px" }}>{children}</div>
      </Paper>
    </Box>
  );
};

interface DatePickerWrapperProps {
  children: React.ReactNode;
  style?: React.CSSProperties;
  className?: string;
}

export const DatePickerWrapper: React.FC<DatePickerWrapperProps> = ({ children, style, className }) => {
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <Stack className={className} style={{ display: "contents", ...style }}>
        {children}
      </Stack>
    </LocalizationProvider>
  );
};

interface DatePickerProps {
  views: DatePickerView;
  minDate?: Date;
  maxDate?: Date;
  label: string;
  value: Date | null;
  inputFormat: string;
  onChange: (value: Date | null) => void;
  className?: string;
  style?: React.CSSProperties;
}

export const DatePickerComponent: React.FC<DatePickerProps> = ({
  onChange,
  value,
  views,
  label,
  inputFormat,
  className,
  style,
  ...rest
}) => {
  return (
    <DatePicker
      views={[views]}
      label={label}
      value={value}
      inputFormat={inputFormat}
      onChange={(value) => onChange(value)}
      renderInput={(params: any) => (
        <TextField
          {...params}
          className={className}
          style={{ marginRight: "10px", textAlignLast: "left", width: 200, ...style }}
          helperText={null}
          size="small"
        />
      )}
      {...rest}
    />
  );
};
